import { render } from "./QuizQuestionTab.vue?vue&type=template&id=ba29343c"
import script from "./QuizQuestionTab.vue?vue&type=script&lang=js"
export * from "./QuizQuestionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__